import React from 'react';

// Inspiro Projects brand mark. Rendered as `<img>` rather than inline SVG
// so any future re-uploads / CDN swaps propagate automatically. The new
// 2026 mark is the "iP" monogram on a black canvas — we wrap it in a
// black rounded tile so the round corners match the artwork's background.
const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_f2e3da60-dd27-470d-bf43-dd90a294a7a5/artifacts/los1nant_WhatsApp%20Image%202026-06-02%20at%2014.31.36.jpeg';

const SIZE_PX = { xs: 20, sm: 28, md: 36, lg: 48, xl: 64 };

export default function BrandLogo({
  size = 'md',
  withWordmark = false,
  wordmarkClassName = '',
  className = '',
  invert = false,
}) {
  const px = SIZE_PX[size] || SIZE_PX.md;
  return (
    <span
      className={`inline-flex items-center gap-2 ${className}`}
      data-testid="brand-logo"
    >
      <img
        src={LOGO_URL}
        alt="Inspiro Projects"
        width={px}
        height={px}
        className={`rounded-lg object-cover bg-black ${invert ? 'ring-1 ring-white/20' : 'ring-1 ring-zinc-200/60'}`}
        style={{ width: px, height: px }}
        loading="eager"
      />
      {withWordmark && (
        <span
          className={`font-['Outfit'] font-bold tracking-tight ${wordmarkClassName || (invert ? 'text-white' : 'text-zinc-900')}`}
        >
          Inspiro Projects
        </span>
      )}
    </span>
  );
}
